import { createFeatureSelector, createSelector } from '@ngrx/store';

import { Trip } from '@models';
import { RouteState, selectRouteState } from '@state/route';
import { TripState } from './trip.state';

export const selectTripState = createFeatureSelector<TripState>('trip');

export const selectTrips = createSelector(
  selectTripState,
  (state: TripState) => state.trips
);

export const selectCurrentTrip = createSelector(
  selectTrips,
  selectRouteState,
  (trips: Trip[], route: RouteState) => {
    return trips.find((x) => x.id === route.params['tripId']);
  }
);

export const selectTripsFetchedAt = createSelector(
  selectTripState,
  (state: TripState) => state.fetchedAt
);
